import { useState } from "react";
import { useLocation } from "react-router-dom";

import { useUsers } from "~/hooks";
import { usePermissions } from "~/screens/Admins/hooks/usePermissions";
import {
  getRoleDescription,
  getRoleLabel,
  ModalProps,
  Role,
  ROLES,
  User,
} from "~/shared.types";
import { Modal } from "~/ui";

export const ChangeUserRoleModal = ({ show, onClose }: ModalProps) => {
  const {
    state: { user },
  } = useLocation() as { state: { user: User } };
  const { changeRoleMutation } = useUsers();
  const { mutate: changeRole, isPending } = changeRoleMutation;
  const { canEditUserType } = usePermissions();

  const [selectedRole, setSelectedRole] = useState<Role>(user.userType);

  const handleConfirm = () => {
    if (!canEditUserType || selectedRole === user.userType) {
      onClose();
      return;
    }

    changeRole({
      id: user.id,
      role: selectedRole,
    });
  };

  return (
    <Modal
      show={show}
      title="Edit User Type"
      onClose={onClose}
      handleConfirm={handleConfirm}
      closeLabel="Cancel"
      isLoading={isPending}
    >
      <div className="flex h-full flex-col justify-between">
        <div className="space-y-4">
          {Object.values(ROLES).map((role) => (
            <label
              key={role.value}
              className="flex cursor-pointer items-start gap-3"
            >
              <input
                type="radio"
                name="userRole"
                value={role.value}
                checked={selectedRole === role.value}
                onChange={(e) => setSelectedRole(e.target.value as Role)}
                className="accent-violet mt-1 h-5 w-5 focus:outline-none"
              />
              <div className="flex-1">
                <div className="text-lg font-medium text-gray-900">
                  {getRoleLabel(role.value)}
                </div>
                <div className="text-sm text-gray-600">
                  {getRoleDescription(role.value)}
                </div>
              </div>
            </label>
          ))}
        </div>
        <p className="text-lg font-medium">
          {`Would you like to make ${user.firstName} ${user.lastName} ${selectedRole.startsWith("a") ? "an" : "a"} ${getRoleLabel(selectedRole)}?`}
        </p>
      </div>
    </Modal>
  );
};
